import * as types from '../mutations'
import CodeService from '@/services/CodeService'
import * as transactionUtils from '@/utils/transaction'

const state = {
  selectedCodeId: null,
  filteredCodes: [],
  formattedCodes: [],
  search: '',
  codes: [],
  count: 0,
  loading: true
}

const getters = {
  selectedCodeId: (state) => state.selectedCodeId,
  filteredCodes: (state) => state.filteredCodes,
  formattedCodes: (state, getters, rootState, rootGetters) =>
    state.filteredCodes.map(code => formatEntity(rootGetters['scmFields/scmFields'], code)),
  search: (state) => state.search,
  codes: (state) => state.codes,
  count: (state) => state.count,
  loading: (state) => state.loading,
  usedCampaigns: (state) => state.filteredCodes.reduce((campaigns, code) => {
    const campaignId = code['campaign']
    if (!campaigns.includes(campaignId))
      campaigns.push(campaignId);
    return campaigns
  }, []),
  getByExtendedId: (state) => (id) => {
    return state.filteredCodes.find(code => code.message == id)
  },
  getByExtendedIdList: (state) => (ids) => state.filteredCodes
    .filter(code => ids.includes(code.message))
    .reduce((res, code) => {
      if (!res[code.message]) res[code.message] = code
      return res
    }, {}),
}

const actions = {

  selectCode ({ commit }, { codeId }) {
    commit(types.SELECT_CODE, codeId)
  },

  clearCodeSelection ({ commit }) {
    commit(types.CLEAR_CODE_SELECTION)
  },

  async searchCode ({ commit }, search) {
    commit(types.SET_SEARCH, search)
    commit(types.CODE_LOADING)
    let data = await CodeService.loadCodes(search)
    commit(types.SET_FILTERED_CODE_LIST, data)
    commit(types.CODE_LOADED)
  },

  async loadCodeList ({ commit, getters }) {
    commit(types.CODE_LOADING)
    let data = await CodeService.loadCodes(getters.search)
    commit(types.SET_CODE_LIST, data.results)
    commit(types.SET_FILTERED_CODE_LIST, data)
    commit(types.CODE_LOADED)
  },

  async fetchByExtendedId ({}, id) {
    return (await CodeService.fetchByExtendedId(id)).results[0]
  }
}

const mutations = {

  [types.SET_SEARCH] (state, search) {
    state.search = search
  },

  [types.SELECT_CODE] (state, codeId) {
    state.selectedCodeId = codeId
  },

  [types.CLEAR_CODE_SELECTION] (state) {
    state.selectedCodeId = null
  },

  [types.SET_CODE_LIST] (state, codes) {
    state.codes = codes
  },

  [types.SET_FILTERED_CODE_LIST] (state, data) {
    state.filteredCodes = data.results
    state.count = data.count
  },

  [types.CODE_LOADING] (state) {
    state.loading = true
  },

  [types.CODE_LOADED] (state) {
    state.loading = false
  }
}

function formatEntity (scmFields, entity) {
  for (let field in scmFields) {
      if (field.type == 'date') {
        entity['scm_data'][field.key] = new Date(entity['scm_data'][field.key]).toLocaleDateString('en-us', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })
      } else {
        entity[field.key] = entity['scm_data'][field.key]
      }
  }
  return entity
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
